// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    EnterpriseCoordinatorAccountUpsearchModelResponse,
    EnterpriseCoordinatorAccountUpsearchRequestModel,
    EnterpriseCoordinatorSiteAccountUpsearchModelResponse,
    EnterpriseCoordinatorSiteAccountUpsearchRequestModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EscoordV1Api extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @summary Search Accounts for match on Program identifier and other criteria.
     * @param enterpriseCoordinatorAccountUpsearchRequestModel Model containing search criteria
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountUpsearchByTenantIdProgramId (enterpriseCoordinatorAccountUpsearchRequestModel: EnterpriseCoordinatorAccountUpsearchRequestModel, xProgramId?: number): Promise<AxiosResponse<EnterpriseCoordinatorAccountUpsearchModelResponse>> {
        const _url_ = '/escoord/v1/AccountUpsearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'enterpriseCoordinatorAccountUpsearchRequestModel' is not null or undefined
        if (enterpriseCoordinatorAccountUpsearchRequestModel === null || enterpriseCoordinatorAccountUpsearchRequestModel === undefined) {
            throw new Error('Required parameter enterpriseCoordinatorAccountUpsearchRequestModel was null or undefined when calling accountUpsearchByTenantIdProgramId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enterpriseCoordinatorAccountUpsearchRequestModel, "EnterpriseCoordinatorAccountUpsearchRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnterpriseCoordinatorAccountUpsearchModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnterpriseCoordinatorAccountUpsearchModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Search Accounts for match on Program identifier and other criteria.
     * @param enterpriseCoordinatorSiteAccountUpsearchRequestModel Model containing search criteria
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteAccountUpsearchByTenantIdProgramId (enterpriseCoordinatorSiteAccountUpsearchRequestModel: EnterpriseCoordinatorSiteAccountUpsearchRequestModel, xProgramId?: number): Promise<AxiosResponse<EnterpriseCoordinatorSiteAccountUpsearchModelResponse>> {
        const _url_ = '/escoord/v1/SiteAccountUpsearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'enterpriseCoordinatorSiteAccountUpsearchRequestModel' is not null or undefined
        if (enterpriseCoordinatorSiteAccountUpsearchRequestModel === null || enterpriseCoordinatorSiteAccountUpsearchRequestModel === undefined) {
            throw new Error('Required parameter enterpriseCoordinatorSiteAccountUpsearchRequestModel was null or undefined when calling siteAccountUpsearchByTenantIdProgramId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enterpriseCoordinatorSiteAccountUpsearchRequestModel, "EnterpriseCoordinatorSiteAccountUpsearchRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnterpriseCoordinatorSiteAccountUpsearchModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnterpriseCoordinatorSiteAccountUpsearchModelResponse");
        }
        return response;
    }
}
